import { render, staticRenderFns } from "./CampaignsIndex.vue?vue&type=template&id=0c97fea2&scoped=true&"
import script from "./CampaignsIndex.vue?vue&type=script&lang=js&"
export * from "./CampaignsIndex.vue?vue&type=script&lang=js&"
import style0 from "./CampaignsIndex.vue?vue&type=style&index=0&id=0c97fea2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c97fea2",
  null
  
)

export default component.exports